import { Caption } from '@/components/@IntranetLibrary/Typography';
import { DeleteButton, Title, Wrapper } from './styled';
import CloseIcon from '@/public/icons/work/close.svg';
import Spinner from '@/components/@IntranetLibrary/Spinner';
import { Box, Stack } from '@mui/material';
import classNames from 'classnames';
import { formatAs } from '@/utils/format';

export type RecentViewedItemProps = {
  readonly id: string;
  readonly title: string;

  readonly authorName?: string;
  readonly authorPosition?: string;
  readonly viewedDate?: string;

  readonly onClick: () => void;
  readonly onDeleteClick?: () => void;
  readonly isDeleting?: boolean;
  readonly isFocused?: boolean;
};

const RecentViewedItem = ({
  title,
  authorName,
  authorPosition,
  viewedDate,
  onClick,
  onDeleteClick,
  isDeleting,
  isFocused,
}: RecentViewedItemProps) => {
  return (
    <Wrapper direction={'row'} className={classNames({ focused: isFocused })}>
      <Box flex={1} sx={{ minWidth: 0, minHeight: 0 }} onClick={onClick}>
        <Title className={'ellipsis'}>{title}</Title>
        {(authorName || viewedDate) && (
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={'8px'}
          >
            <Stack direction={'row'} alignItems={'center'} gap={'4px'}>
              <Caption className={'ellipsis'} sx={{ maxWidth: '80px' }}>
                {authorName}
              </Caption>
              <Caption className={'ellipsis'}>{authorPosition}</Caption>
            </Stack>
            {viewedDate && (
              <Caption className={'ellipsis'}>
                {formatAs(viewedDate, 'date')}
              </Caption>
            )}
          </Stack>
        )}
      </Box>
      {onDeleteClick && (
        <DeleteButton
          disableRipple
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClick();
          }}
          disabled={isDeleting}
          className={'delete-button'}
        >
          {isDeleting ? (
            <Spinner theme={'black'} size={'20px'} />
          ) : (
            <CloseIcon />
          )}
        </DeleteButton>
      )}
    </Wrapper>
  );
};

export default RecentViewedItem;
